import * as types from "./mutationTypes";

export default {
  [types.ADD_VALIDATOR](state, { field, validator }) {
    if (!state.validator) {
      state.validator = {};
      state.errors = [];
    }
    state.validator[field] = validator;
  },
  [types.ADD_ERROR](state, error) {
    state.errors.push(error);
  },
  [types.REMOVE_ERROR](state, field) {
    state.errors = state.errors.filter((error) => error.field !== field);
  },
  [types.CLEAR_VALIDATOR](state) {
    state.validator = null;
    state.errors = [];
  }
};
